import { ApiError } from "@tsmono/util";

// Maps an edit_log failure to the message EditAnnotationsDialog shows.
//
// Assumes `ApiError.message` is already the bare server detail (no
// `"API Error N: ..."` prefix, no `{"detail": "..."}` envelope) — the
// view-server and vscode edit_log callers both unwrap FastAPI's
// `HTTPException` body before throwing, so this mapper just decides
// when to substitute a canned UI string vs. surface the server's
// message verbatim.
export function formatEditError(err: unknown): string {
  if (err instanceof ApiError) {
    if (err.status === 412) {
      // Concurrent-modification — the server's message is technical
      // ("ETag mismatch"); the canned wording tells the user what to
      // actually do.
      return "This log was modified by someone else. Please reload and try again.";
    }
    // 400 (validation), 409 (in-progress), and any other status:
    // surface the server's human-readable detail directly.
    return err.message;
  }
  // `fetch()` throws a `TypeError` (with browser-specific messages like
  // "Failed to fetch", "NetworkError when attempting to fetch
  // resource.", or "Load failed") when the request never reaches the
  // server — most commonly because the view server has shut down.
  // Surface a clearer message than the raw browser text.
  if (err instanceof TypeError) {
    return "Connection lost — view server unreachable.";
  }
  if (err instanceof Error) {
    return err.message;
  }
  return String(err);
}
